import { Util } from '../utils/Commom';
export var process = function (chart, config) {
    var cDefs = Util.deepClone(config.defs);
    var isArr = Util.isArray(cDefs);
    var options = {};
    if (!Util.isEmpty(cDefs)) {
        var arrDefs = isArr ? cDefs : [cDefs];
        for (var _i = 0, arrDefs_1 = arrDefs; _i < arrDefs_1.length; _i++) {
            var res = arrDefs_1[_i];
            if (res.dataKey) {
                var currOption = Util.omit(res, 'dataKey');
                options[res.dataKey] = currOption;
            }
        }
    }
    if (Util.isEmpty(config.data)) {
        config.data = [];
    }
    if (!Util.isEmpty(config.series)) {
        var cData = Util.deepClone(config.data);
        var arrData = Util.isArray(cData) ? cData : [cData];
        chart.source(arrData, options);
    }
};
//# sourceMappingURL=setDataConfig.js.map